export * from './buscador/vista-servicios-registrados-buscador.component';
export * from './detalle/vista-servicios-registrados-detalle.component';
export * from './lista/vista-servicios-registrados-lista.component';
export * from './formulario/vista-servicios-registrados-formulario.component';
export * from './hoja-ruta/vista-servicios-registrados-hoja-ruta.component';
export * from './cpt/vista-servicios-registrados-cpt.component';
export * from './impresion-hoja-ruta/vista-servicios-registrados-impresion-hoja-ruta.component';
export * from './formulario-validacion/vista-servicios-registrados-formulario-validacion.component';
export * from './documento-orden-servicio/vista-servicios-registrados-documento-orden-servicio.component';
